const VALIDATION_MESSAGES = {
  ein: 'Please use the following format: XX-XXXXXXX.',
  regulatoryId: 'A regulatory ID consists of a 4-digit agency code plus a 4-character alphanumeric code. Please use the format: XXXX-XXXX.',
  website: 'Website URLs must begin with "https://" and contain a single top level domain such as .gov, .org, etc.'
};

export default VALIDATION_MESSAGES;
